/*###########################################################################
	duvet cover width size check
#############################################################################*/
$(function () {
$(document).on("change", "#number-1", function(){  
  var wsize = ($('#number-1').val());
  var selectSize = $("input[name='option-0']:checked").val();
  if(wsize < 160){
  	if(selectSize != '140cm-159cm'){
  		$('#number-1').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-1').focus();
  	}
  }else if(wsize >= 160 && wsize < 180){
  	if(selectSize != '160cm-179cm'){
  		$('#number-1').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-1').focus();
  	}
  }else if(wsize >= 180 && wsize < 200){
  	if(selectSize != '180cm-199cm'){
  		$('#number-1').val('');
  		alert("選択した範囲内でサイズを入力してください。");
   		$('#number-1').focus(); 		
  	}
  }else if(wsize >= 200 && wsize < 220){
  	if(selectSize != '200cm-219cm'){
  		$('#number-1').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-1').focus();
  	} 
   }else if(wsize >= 220 && wsize < 240){
  	if(selectSize != '220cm-239cm'){
  		$('#number-1').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-1').focus();
  	}  
     }else if(wsize >= 240 && wsize < 260){
  	if(selectSize != '240cm-259cm'){
  		$('#number-1').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-1').focus();
  	} 
     }else if(wsize >= 260 && wsize < 280){
  	if(selectSize != '260cm-279cm'){
  		$('#number-1').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-1').focus();
  	}  
  }else if(wsize >= 281){
  	$('#number-1').val('');
  	alert("280cm以上は入力できません。");
  	$('#number-1').focus();
  }
});
});
/*###########################################################################
	duvet cover height size check
#############################################################################*/
$(function () {
$(document).on("change", "#number-2", function(){  
  var wsize = ($('#number-2').val());
  var selectSize = $("input[name='option-1']:checked").val();
  if(wsize < 211){
  	if(selectSize != '200cm-210cm'){
  		$('#number-2').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-2').focus();
  	}
  }else if(wsize >= 211 && wsize < 221){
  	if(selectSize != '200cm-220cm'){
  		$('#number-2').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-2').focus();
  	}
    }else if(wsize >= 221 && wsize < 231){
  	if(selectSize != '221cm-230cm'){
  		$('#number-2').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-2').focus();
  	}
    }else if(wsize >= 231 && wsize < 241){
  	if(selectSize != '231cm-240cm'){
  		$('#number-2').val('');
  		alert("選択した範囲内でサイズを入力してください。");
  		$('#number-2').focus();
  	}
  }else if(wsize >= 241){
  	$('#number-2').val('');
  	alert("241cm以上は入力できません。");
  	$('#number-2').focus();
  }
});
});
/*###########################################################################
	sheets height size check Radio btn change
#############################################################################*/
$(function () {
    $("input[name='option-0']").change(function () {
		var widthSize = ($('#number-1').val());
        var newWidthSize = $(this).val();
		if(widthSize != ""){
			$('#number-1').val('');
			alert("サイズが変更されました。実際の幅を再入力してください。");
			$('#number-1').focus();
		}
    });
});

$(function () {
    $("input[name='option-1']").change(function () {
		var heightSize = ($('#number-2').val());
        var newSize = $(this).val();
		if(heightSize != ""){
			$('#number-2').val('');
			alert("サイズが変更されました。実際の丈を再入力してください。");
			$('#number-2').focus();
		}
    });
});